import { Avatar, Badge, Box, Group, Text } from '@mantine/core';

const fakePrincesses = [
  { id: 1,  name: 'Princess Lily',    handle: '@lily_toes',      img: 'https://picsum.photos/seed/feet-lily/200/200',    tags: ['Red Nail Polish', 'Soft Soles'] },
  { id: 2,  name: 'Princess Rose',    handle: '@rosie_piggies',  img: 'https://picsum.photos/seed/feet-rose/200/200',    tags: ['French Manicure', 'High Arches'] },
  { id: 3,  name: 'Princess Jade',    handle: '@jade_feet',      img: 'https://picsum.photos/seed/feet-jade/200/200',    tags: ['Gel Nails', 'Ankle Bracelets'] },
  { id: 4,  name: 'Princess Violet',  handle: '@vi_toes',        img: 'https://picsum.photos/seed/feet-violet/200/200',  tags: ['Purple Nail Polish', 'Barefoot'] },
  { id: 5,  name: 'Princess Nova',    handle: '@nova_piggies',   img: 'https://picsum.photos/seed/feet-nova/200/200',    tags: ['Glitter Nail Polish', 'Toe Rings'] },
  { id: 6,  name: 'Princess Sage',    handle: '@sage_soles',     img: 'https://picsum.photos/seed/feet-sage/200/200',    tags: ['Spa Pedicure', 'Smooth Soles'] },
  { id: 7,  name: 'Princess Dahlia',  handle: '@dahlia_toes',    img: 'https://picsum.photos/seed/feet-dahlia/200/200',  tags: ['Pink Nail Polish', 'Heels'] },
  { id: 8,  name: 'Princess Ember',   handle: '@ember_piggies',  img: 'https://picsum.photos/seed/feet-ember/200/200',   tags: ['Chrome Nails', 'Tattoos'] },
  { id: 9,  name: 'Princess Luna',    handle: '@luna_feet',      img: 'https://picsum.photos/seed/feet-luna/200/200',    tags: ['Matte Nail Polish', 'Soft Soles'] },
  { id: 10, name: 'Princess Coral',   handle: '@coral_toes',     img: 'https://picsum.photos/seed/feet-coral/200/200',   tags: ['Nude Nail Polish', 'Sandals'] },
];

const PrincessCard = ({ princess }) => (
  <Box
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 8,
      padding: '16px 12px',
      margin: '0 10px',
      width: 140,
      borderRadius: 16,
      background: 'rgba(255,255,255,0.75)',
      border: '1px solid rgba(159,56,204,0.15)',
      boxShadow: '0 2px 8px rgba(159,56,204,0.1)',
      flexShrink: 0,
    }}
  >
    <Avatar
      src={princess.img}
      size={90}
      radius="50%"
      style={{ border: '3px solid #9f38cc' }}
    />
    <Text size="sm" fw={600} ta="center" c="grape" style={{ lineHeight: 1.2 }}>
      {princess.name}
    </Text>
    <Text size="xs" c="dimmed" ta="center">
      {princess.handle}
    </Text>
    <Group gap={4} justify="center" wrap="wrap">
      {princess.tags.map(tag => (
        <Badge key={tag} size="xs" color="pink" variant="light" style={{ fontSize: 9 }}>
          {tag}
        </Badge>
      ))}
    </Group>
  </Box>
);

const PrincessCarousel = () => {
  const allCards = [...fakePrincesses, ...fakePrincesses];

  return (
    <Box style={{ overflow: 'hidden', width: '100%' }}>
      <Text size="sm" fw={500} c="dimmed" ta="center" mb="md">
        Meet some of our princesses ✨
      </Text>
      <Box style={{ overflow: 'hidden', width: '100%' }}>
        <div className="princess-marquee-track">
          {allCards.map((princess, i) => (
            <PrincessCard key={`${princess.id}-${i}`} princess={princess} />
          ))}
        </div>
      </Box>
    </Box>
  );
};

export default PrincessCarousel;
